/**
 * Which Heilmittelvereinbarungs-Anlage a SDHMA prescription-need entry belongs to
 * (anlage_heilmittelvereinbarung@V).
 *
 * - `BVB` — Besondere Verordnungsbedarfe (a diagnosis that does not count against
 *   the Verordnungsfall budget for a limited window).
 * - `LHM` — Langfristiger Heilmittelbedarf (a diagnosis granting a standing,
 *   long-term entitlement).
 *
 * Both are informational for validation — a badge, never a violation (fixed
 * decision #6) — but the distinction drives which copy is shown.
 */
export var CatalogAnlage;
(function (CatalogAnlage) {
    CatalogAnlage["BVB"] = "BVB";
    CatalogAnlage["LHM"] = "LHM";
})(CatalogAnlage || (CatalogAnlage = {}));
//# sourceMappingURL=catalog-anlage.enum.js.map